export const isVerticalBottomIntersect = (source, target): boolean => {
	const isOverlap = (source.pi === null || target.top >= source.bottom) &&
		target.i !== source.i &&
		(
			/* left edge outside, but right edge overlaps (overlaps left side of source)*/
			(target.left >= source.left && target.left <= source.right) ||
			/* right edge outside, but left edge overlaps (overlaps right side of source)*/
			(target.right <= source.right && target.right >= source.left) ||
			/* left edge outside left edge of target, right edge outside right edge of target (target equal to or wider than source, complete overlap)*/
			(target.left <= source.left && target.right >= source.right)
		);
	// console.log(`isBottomIntersect (${source.pi?.item?.sku ?? 'null'} -> ${target.pi?.item?.sku ?? 'null'} = ${isOverlap})`, { source, target });
	return isOverlap;
};
